import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-title align-items-start flex-column"
}
const _hoisted_2 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "text-muted mt-1 fw-bold fs-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    header: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 12 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              ($props.text || $props.description)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_1, [
                    _createElementVNode("span", _hoisted_2, _toDisplayString($props.text), 1),
                    _hoisted_3,
                    _createElementVNode("span", _hoisted_4, _toDisplayString($props.description), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 8 }),
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "nav")
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}